import { Module } from 'vuex';
import { RootState } from '@/store/store';
import { PendingCitationsState, initialState } from './pending-citations.state';
import { pendingCitationsActions } from './pending-citations.actions';
import { pendingCitationsMutations } from './pending-citations.mutations';

export const pendingCitationsModule: Module<
  PendingCitationsState,
  RootState
> = {
  namespaced: true,
  state: initialState,
  mutations: pendingCitationsMutations,
  actions: pendingCitationsActions,
  getters: {
    getCitationsForDocument: (state) => (documentId: number) => {
      return state.citationsByDocumentId[documentId] || [];
    },

    getActiveCitationsForDocument: (state) => (documentId: number) => {
      const citations = state.citationsByDocumentId[documentId] || [];
      return citations.filter((citation) => citation.status === 'ACTIVE');
    },

    getArchivedCitationsForDocument: (state) => (documentId: number) => {
      const citations = state.citationsByDocumentId[documentId] || [];
      return citations.filter((citation) => citation.status === 'ARCHIVED');
    },

    isLoading: (state) => {
      return (
        state.apiState.getPendingCitations.loading ||
        state.apiState.addPendingCitation.loading ||
        state.apiState.updatePendingCitation.loading
      );
    },

    isGetPendingCitationsLoading: (state) =>
      state.apiState.getPendingCitations.loading,
    isAddPendingCitationLoading: (state) =>
      state.apiState.addPendingCitation.loading,
    isUpdatePendingCitationLoading: (state) =>
      state.apiState.updatePendingCitation.loading,
    isArchivePendingCitationLoading: (state) =>
      state.apiState.archivePendingCitation.loading,
    isDeletePendingCitationLoading: (state) =>
      state.apiState.deletePendingCitation.loading,
    isImportPendingCitationsLoading: (state) =>
      state.apiState.importPendingCitations.loading
  }
};
